import { ApiExec, ApiExecDecrypted } from '@utils/ApiExec';

class EstructuraServices {
    getEstructuraCapacitadores = (data) => ApiExec(data, "foca/get-estructura", "POST");
    getSecretariaFormacion = (params) => ApiExec(params, "foca/get-secretaria-formacion", "POST");

    updateEstructuraCapacitadores = (params) => ApiExec(params, "foca/update-estructura", "PUT");
    updateUserEstructura = (params) => ApiExecDecrypted(params, "foca/update-user-estructura", "PUT", false);
    deleteEstructura = (params) => ApiExec(params, "foca/delete-estructura", "PUT");
}

const service = new EstructuraServices();
export default service;
